export default {
  apiKey: "AIzaSyCdNCMFf2uC5fdRtp_WL2ar4x-bUUqW8Zw",
  authDomain: "nfstock-a388a.firebaseapp.com",
  databaseURL: "https://nfstock-a388a.firebaseio.com",
  projectId: "nfstock-a388a",
  storageBucket: "nfstock-a388a.appspot.com",
  messagingSenderId: "400940162578"
}